import { render, staticRenderFns } from "./statistical-analysis-general-statistics-detail.vue?vue&type=template&id=4b1e2cae&scoped=true&"
import script from "./statistical-analysis-general-statistics-detail.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-general-statistics-detail.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-general-statistics-detail.scss?vue&type=style&index=0&id=4b1e2cae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e2cae",
  null
  
)

export default component.exports